import { CommonTouchBase, MouseTouchOption, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { InputCanvasProps } from '../ZEDCameraInputManager';

let isTapping = false;
export const SingleTouchWindowView: CommonTouchBase & MouseTouchOption = {
  type: 'CommonTouch',
  touchCount: 1,
  key: 'SingleTouchWindowView',
  name: 'SingleTouchWindowView',
  option: {
    mouseButton: 'all',
    mouseKeyCode: 'none',
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {
    isTapping = false;
  },
  onMousedown(camera, _touchData, _canvasProps) {
    isTapping = true;
    camera.stopPlayingAnimation();
  },
  onMousemove(_camera: ZEDCamera, touchData: TouchData, _canvasProps: InputCanvasProps) {
    if (touchData.dragVector.length() > 10.0) isTapping = false;
  },
  onMouseup(_camera: ZEDCamera, _touchData: TouchData, _canvasProps: InputCanvasProps) {},
  onTouchStart(camera, _touchData, _canvasProps) {
    isTapping = true;
    camera.stopPlayingAnimation();
  },
  onTouchMoved(_camera, touchData, _canvasProps) {
    if (touchData[0] && touchData[0].dragVector.length() > 10.0) isTapping = false;
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {},
};
